import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import {
    ToughCompIcon,
    TakesTimeIcon,
    FiananceIcon,
} from "../../../app-constants"

const Startupslider = () => {
    return (
        <div className="startup_slider p-100">
            <Container >
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="m-auto text-center">
                        <h2>Challenges A Startup App Faces</h2>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                        <div className="startup_main">
                            <div className="startup_img">
                                {ToughCompIcon}
                            </div>
                            <div className="startup_content">
                                <h5>The Tough Competition</h5>
                                <p>Establishing yourself in the crowded market of today can be a challenge. According to research, in August 2020, 111 thousand mobile apps were launched on Google Play Store, and 31.8 thousand apps were launched on Apple Store.</p>
                                <p>Through these stats, you can quickly develop an idea of the competitive market your startup app would face. Plus, intriguing your audience to keep using your app is also a challenge.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                    <div className="startup_main">
                            <div className="startup_img">
                                {TakesTimeIcon}
                            </div>
                            <div className="startup_content">
                                <h5>It Takes Time</h5>
                                <p>Depending on the app's complexity, structure, and functionality, it can take a significant amount of time to get it out to the masses.</p>
                                <p>Moreover, outsourcing your app development will surely be a better option because, firstly, you'll have a team of professionals working on your app. Secondly, you'll have all the resources required to launch your app on time.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4} >
                    <div className="startup_main">
                            <div className="startup_img">
                                {FiananceIcon}
                            </div>
                            <div className="startup_content">
                                <h5>The Tough Competition</h5>
                                <p>Establishing yourself in the crowded market of today can be a challenge. According to research, in August 2020, 111 thousand mobile apps were launched on Google Play Store, and 31.8 thousand apps were launched on Apple Store.</p>
                                <p>Through these stats, you can quickly develop an idea of the competitive market your startup app would face. Plus, intriguing your audience to keep using your app is also a challenge.</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Startupslider